import { render, staticRenderFns } from "./detail_dzzb_info.vue?vue&type=template&id=7f5b7a82&scoped=true&"
import script from "./detail_dzzb_info.vue?vue&type=script&lang=js&"
export * from "./detail_dzzb_info.vue?vue&type=script&lang=js&"
import style0 from "./detail_dzzb_info.vue?vue&type=style&index=0&id=7f5b7a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5b7a82",
  null
  
)

export default component.exports